import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { authService } from "../services/auth";

const UpdatePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (password.length < 6) {
      setError("A senha deve ter pelo menos 6 caracteres.");
      return;
    }

    if (password !== confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    setLoading(true);

    try {
      await authService.updatePassword(password);
      setMessage("Senha atualizada com sucesso. Já pode iniciar sessão.");
      setPassword("");
      setConfirmPassword("");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(
        err.message ||
          "Não foi possível atualizar a senha. O link pode ter expirado, pede uma nova recuperação."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="app"
      className="min-h-screen bg-neutral-50 flex items-center justify-center"
    >
      <div className="w-full max-w-md">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <div className="text-center mb-8">
            <img
              src="https://i.imgur.com/cRpaPnC.jpeg"
              alt="Logo"
              className="h-12 w-50 mx-auto"
            />
            <h2 className="mt-4 text-2xl">Definir Nova Senha</h2>
            <p className="mt-2 text-sm text-neutral-500">
              Escolha uma nova senha para a sua conta
            </p>
          </div>

          {error && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6"
              role="alert"
            >
              {error}
            </div>
          )}
          {message && (
            <div
              className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-6"
              role="alert"
            >
              {message}
            </div>
          )}

          <form onSubmit={handleUpdatePassword}>
            <div className="space-y-6">
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm text-neutral-700"
                >
                  Nova senha
                </label>
                <div className="mt-1 relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FontAwesomeIcon
                      icon={faLock}
                      className="text-neutral-500"
                    />
                  </div>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={6}
                    className="block w-full pl-10 pr-3 py-2 border border-neutral-300 rounded-md focus:ring-1 focus:ring-neutral-500 focus:border-neutral-500"
                    placeholder="••••••••"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="confirmPassword"
                  className="block text-sm text-neutral-700"
                >
                  Confirmar nova senha
                </label>
                <div className="mt-1 relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FontAwesomeIcon
                      icon={faLock}
                      className="text-neutral-500"
                    />
                  </div>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    minLength={6}
                    className="block w-full pl-10 pr-3 py-2 border border-neutral-300 rounded-md focus:ring-1 focus:ring-neutral-500 focus:border-neutral-500"
                    placeholder="••••••••"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-white bg-neutral-900 hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Atualizando..." : "Atualizar senha"}
              </button>
            </div>
          </form>

          <div className="mt-6 text-center text-sm">
            <span
              onClick={() => navigate("/")}
              className="text-neutral-600 hover:text-neutral-900 cursor-pointer"
            >
              Voltar ao login
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
